import multiGuard from '@/router/utils/vue-router-multiguard'
import fetchBusinessTypesGuard from '@/router/guards/fetch-business-types-guard'
import mobileAppGuard from '@/router/guards/mobile-app-guard'

export default [
  {
    path: 'notifications',
    name: 'admin:mobile:notifications',
    beforeEnter: multiGuard([fetchBusinessTypesGuard, mobileAppGuard]),
    component: () => import(/* webpackChunkName: "mobile-app" */ '@/views/admin/mobile/notifications/CampaignsTable.vue'),
  },
]
